export const deliverabilitySndsAppGroupIdLatestEvent = "/deliverability/snds/:app_group_id/latest_event";
